var Backbone = require('backbone'),
    _ = require('underscore'),
    DocMdPage = require('./pgDocMode.js'),
    fvChannel = require('glRadio').channel('FV');


/* inst:
*    V_PADDING
*    H_PADDING
*    totalPagesHeight
*    parentDocument
* */

/* Note: thumbs extended from this) */
module.exports = Backbone.Collection.extend({

    model: DocMdPage, /* (derived from base page */

    initialize: function(models, options) {

        var cssConstants = fvChannel.request('cssConstants');
        this.totalPagesHeight = 0;
        this.parentDocument = options.parentDocument; //(can also ref state from here)
        this.V_PADDING = cssConstants.V_PADDING;  //used in voffset and scale calc
        this.H_PADDING = cssConstants.H_PADDING;  //used in scale calc via ref to collection -- GET elsewhere?
        _.bindAll(this, 'setVOffsets');


    },

    /* Add Page Number to the models from the array index (also parsed individually) */
    parse: function(models) {
        return _.map(models, function(m, i) {
            return _.extend(m, {number: i+1});
        });
    },

    /**
     * Called from:
     * - post render docMode view ( TODO - should now have enough info to call prior to rendering )
     * - Document mode scale change
     * - Post page rotation: new
     * - Most be called after a 'page size' change
     * The bottom of the page relative to the top of its scroll container ( Doc Mode El )
     *
     */
    setVOffsets: function(scale) {

        var vPadding =  this.V_PADDING,
            pages = this.models,
            numPages = pages.length,
            pagePadding = (2 * vPadding), /* the vertical padding of the imgWr (no more border --uses outline) -- need to check this now */
            totalPagesHeight = 0; // Note: should equal docMode scroll height tough could be off a bit due to rounding

        /* GOOD OLE for for performance */
        for (var i=0; i < numPages; i++) {

            var pg = pages[i],
                pgHt = Math.round( pg.getRotatedHeight() * scale ),
                roundedBottom = pgHt + pagePadding; /* don't scale the padding -- note: using outline, not border -- so not included */

            totalPagesHeight += roundedBottom;

            pg.set({ 'vOffset': totalPagesHeight });
        }

        // Note: no longer need to add an extra vPadding to -- format must have changed .
        this.totalPagesHeight = totalPagesHeight;

    },

    getRequestedButUnloadedModels: function() {
        return this.where({
            isLoaded: false,
            wasRequested: true
        });
    },

    noRenderablePagesExist: function() { /* note: set on pg init */
        return this.where({isRenderable: true}).length < 1;
    },

    someRenderablePagesExist: function() {
        var unRenderablePgs = this.getUnrenderablePages();
        return unRenderablePgs.length > 0 && unRenderablePgs.length < this.length;
    },

    getUnrenderablePages: function() { //return subset of pages that are not renderable
        return new Backbone.Collection( this.where({isRenderable: false}) );
    },

    getModelFromPgNumber: function(pgNumber) { /* Works Page or Thumb */
        return this.at( pgNumber -1 );
    },

    unrenderablePDFModePgs: function() {
        return new Backbone.Collection( this.filter(function(p) {
            return p.isRenderableInPDFMode();
        }));
    },

    noPDFRenderablePagesExist: function() {
        return this.unrenderablePDFModePgs().length < 1;
    },

    somePDFRenderablePgsExist: function() {
        var unRenderablePDFPgs = this.unrenderablePDFModePgs();
        return unRenderablePDFPgs.length > 0 && unRenderablePDFPgs.length < this.length;
    },

    urlOrUnrenderablePages: function() {

        return new Backbone.Collection( this.filter(function(p) {
            return p.isUrlOrUnrenderable();
        }));

    },
    hasMultipartGosPages: function() {

        return this.find( function(p) {
            return p.isMultipartGos();
        }) !== undefined;

    },

    allPagesAreUrlPages: function() {

        var numberUrlPages = this.filter(function(p) {
            return p.isUrl();
        }).length;

        return numberUrlPages === this.length;

    },

    pagesWithPositionalData: function() {

        return this.filter( function(p) {
            return p.hasPositionalTextData();
        });

    },

    getPositionalTextModelOfPage: function( pageNumber ) {

        var page = this.findWhere({ number: pageNumber} );

        return page
            ? page.getPositionalTextDataModel()
            : null; // use null as 'falsey' value; null returned from server if ocrNote doesn't exist

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pages.js
 ** module id = 398
 ** module chunks = 0
 **/